<template>
  <div>
    <Edit
        :item="currentItem"
        :close="closeEdit"
        :onSubmit="onSubmit"
    />
    <NavBar/>
    <div class="container">
      <SideBar/>
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>

          <!-- título superior -->
          <h1 class="title">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z" class=""></path></svg>
            Vitrines
          </h1>

          <!-- título (aba) -->
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/noticias">Vitrines</router-link>
            </li>
          </ul>

          <!-- conteúdo -->
          <div class="card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Titulo</th>
                    <th>Cor</th>
                    <th>Ordem</th>
                    <th>Coluna View</th>
                    <th>Slug</th>
                    <th>Ativo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in vitrines">
                    <td>{{ row.titulo }}</td>

                    <td align="center">
                      <div style="width: 15px; height: 15px;" v-bind:style="{ 'background-color': row.cor }"></div>
                    </td>
                    <td align="center">{{ row.ordem }}</td>
                    <td>{{ row.coluna.toUpperCase() }}</td>
                    <td>/{{ row.slug }}</td>
                    <td>{{ row.ativo | boolean }}</td>
                    <td class="actions">
                      <button type="button" class="button button-primary" v-on:click="openEdit(row)">
                         <svg x="0px" y="0px" style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;" viewBox="0 0 485.219 485.22">
                           <g>
                             <path d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"/>
                           </g>
                         </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import clone from 'just-clone'
  import {request, get, post, put} from '@/helpers/apiRequest'
  import Edit from './Edit'

  const initialItem = {
    id: "",
    label: "",
    titulo: "",
    slug: "",
    cor: "#000",
    tag_produto: "",
    ativo: true,
    ordem: 0,
    coluna: "",
    valor: 1
  }

  export default {
    name: "vitrines",
    components: {
      Edit,
    },
    data() {
      return {
        vitrines: [],
        loading: false,
        currentItem: {}
      }
    },
    filters: {
      boolean(value) {
        return value ? 'Sim' : 'Não'
      }
    },
    methods: {
      loadVitrines() {
        this.loading = true;
        get(`/vitrines`)
          .then(json => {
            this.vitrines = json;
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      },
      openEdit(item) {
        this.currentItem = clone(item)
        this.$modal.show("vitrineEdit");
      },
      closeEdit() {
        this.currentItem = clone(initialItem)
        this.$modal.hide("vitrineEdit");
      },
      onSubmit(item) {
        this.loading = true
        const id = item._id
        delete item._id

        const request = put(`/vitrines/${id}`, item)
        request.then(() => {
          this.closeEdit()
          this.loadVitrines()
        })
          .catch(error => {
            this.loading = false
            this.error = error
          })
        return request
      },
    },
    beforeMount() {
      this.loadVitrines()
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Vitrines/Vitrines.vue